import { jsx as _jsx } from "react/jsx-runtime";
import { tailwindMerge } from "@air/tailwind-variants";
import { DRAG_PREVIEW_HEIGHT, DRAG_PREVIEW_WIDTH } from "~/constants/dnd";
export const DndDragPreviewContainer = (param)=>{
    let { className, style, ...props } = param;
    return /*#__PURE__*/ _jsx("div", {
        className: tailwindMerge("rounded bg-grey-1 p-1 shadow-kanban dark:border dark:border-grey-5", className),
        style: {
            width: DRAG_PREVIEW_WIDTH,
            height: DRAG_PREVIEW_HEIGHT,
            ...style
        },
        ...props
    });
};
